import moment from "moment";

export const getTimeAgo = (createdAt) => {
  const now = moment();
  const createdTime = moment(createdAt);
  const diffSeconds = now.diff(createdTime, "seconds");
  const diffMinutes = now.diff(createdTime, "minutes");

  if (diffSeconds < 60) {
    return `${diffSeconds} sekonda më parë`;
  } else if (diffMinutes < 60) {
    return `${diffMinutes} minuta më parë`;
  } else if (diffMinutes < 1440) {
    return `${Math.floor(diffMinutes / 60)} orë më parë`;
  } else {
    return `${Math.floor(diffMinutes / 1440)} ditë më parë`;
  }
};
